import { isProblem } from '@/lib/api/problem';

/**
 * The BP-04 problem URNs a screen branches on, copied verbatim from
 * `api/app/modules/scheduling/problems.py`.
 *
 * `lib/api/problem.ts`'s `PROBLEM` map is BP-01's and this build plan does not edit it, so
 * the scheduling URNs live with the feature that reacts to them.
 */
export const BOOKING_PROBLEM = {
  illegalTransition: 'urn:26ad:booking-illegal-transition',
  slotTaken: 'urn:26ad:booking-slot-taken',
  cutoffPassed: 'urn:26ad:booking-cutoff-passed',
  rescheduleLimit: 'urn:26ad:booking-reschedule-limit',
  outsideWindow: 'urn:26ad:booking-outside-window',
  notFound: 'urn:26ad:booking-not-found',
  reasonRequired: 'urn:26ad:booking-reason-required',
  staffLacksSkill: 'urn:26ad:staff-lacks-skill',
  noStation: 'urn:26ad:booking-no-station',
  otpInvalid: 'urn:26ad:otp-invalid',
  otpRateLimited: 'urn:26ad:otp-rate-limited',
  badLink: 'urn:26ad:booking-link-invalid',
} as const;

/** True when `error` is the api saying the slot went while the operator was deciding. */
export function isSlotTaken(error: unknown): boolean {
  return isProblem(error) && error.type === BOOKING_PROBLEM.slotTaken;
}

/** True when the api refused for want of a reason (R1's cancel / no-show guard). */
export function isReasonRequired(error: unknown): boolean {
  return isProblem(error) && error.type === BOOKING_PROBLEM.reasonRequired;
}

/** True when the client's cut-off has passed (R6) — the client app explains, not retries. */
export function isCutoffPassed(error: unknown): boolean {
  return isProblem(error) && error.type === BOOKING_PROBLEM.cutoffPassed;
}

/** The api's own sentence for a problem, or `fallback` for anything else. */
export function problemMessage(error: unknown, fallback: string): string {
  return isProblem(error) ? (error.detail ?? error.title) : fallback;
}
